module.exports = __webpack_public_path__ + "img/list_style.5bd87392.svg";